import { API, APIUrlencoded, getAuthHeaders } from './axiosInstance'

export const getUserData = () => APIUrlencoded.get(`/user`, getAuthHeaders()).then(res => res.data)

export const updateUserData = (data) => API.put(`/user`, data, getAuthHeaders()).then(res => res.data)
